import { render } from "./SourceExternalLinks.vue?vue&type=template&id=0bd172ce"
import script from "./SourceExternalLinks.vue?vue&type=script&lang=js"
export * from "./SourceExternalLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__